import { createContext } from 'react';

import type { ProfileFormContextValue } from '../types/profileFormContext';

export const ProfileFormContext = createContext<ProfileFormContextValue | null>(null);
